/**
 * Catégories de points d'intérêt d'un site de festival.
 *
 * Partagées entre le générateur de tuiles, l'application et le back-office : une
 * catégorie ajoutée ici doit l'être partout, et nulle part ailleurs.
 */
export const POI_CATEGORIES = [
  "stage",
  "food",
  "bar",
  "toilets",
  "water",
  "firstaid",
  "info",
  "charging",
  "lockers",
  "entrance",
  "exit",
  "accessible",
] as const;

export type PoiCategory = (typeof POI_CATEGORIES)[number];

/**
 * Catégories relevant de la sécurité des personnes.
 *
 * Elles ne sont jamais monnayables et restent dans le socle de l'offre
 * (MODELE-ECONOMIQUE.md §3.1). Sur une page non officielle, elles ne sont
 * affichées que si un organisateur les a validées (DESIGN.md §2.2).
 */
export const SAFETY_CATEGORIES: readonly PoiCategory[] = ["firstaid", "exit", "water"];

export function isSafetyCategory(category: PoiCategory): boolean {
  return SAFETY_CATEGORIES.includes(category);
}
